import styled from 'styled-components'
import { HEADER_HEIGHT, myPalette } from '~/shared/ui/theme'

export const WrapperHeader = styled.div`
  height: ${HEADER_HEIGHT};
  display: flex;
  align-items: center;
`

export const WrapperFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const Title = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: ${myPalette.aliceBlue.main};
`

export const EmptyMessage = styled.div`
  font-size: 16px;
  text-align: center;
  margin: 16px 0;
`
